import portalProveedoresApi from '../api/portalProveedoresApi'
import authHeader from '../services/auth-header'

const comprobarCodigoObra = async (Metadatos) => {

  try {
    const { data } = await portalProveedoresApi.post('/ComprobarCodigoObra',  {Metadatos} , { headers: authHeader() })
    console.log(data)
    return data
  } catch (error) {
    console.log(error)
    return null
  }
}

export default comprobarCodigoObra
